
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns-policy",
      function () {
        return require("private-next-pages/returns-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/returns-policy"])
      });
    }
  